module.exports = __webpack_public_path__ + "static/img/icon3.9eae2f3b.svg";